/**
 * IMPORTS
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

// typings
import {
  IEnderecoResponseAtualizar,
  IEnderecosPayloadAtualizar,
} from "@/hooks/enderecos/atualizar/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

// domain / caso de usos
import { handleAtualizarEndereco } from "@/domain/use-cases/enderecos/atualizar";

const notifySuccess = (message: string) =>
  toast(message, {
    type: "success",
    position: "top-center",
  });

type IDataApi = {
  payload: IEnderecosPayloadAtualizar;
  endereco_id: number;
};
/**
 * Função que atualizar um endereço
 * @param user_id id do usuário dono do endereço
 * @returns
 */
export function useAtualizarEndereco() {
  const queryClient = useQueryClient(); // ← necessário para invalidar a query
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<
    IEnderecoResponseAtualizar, // tipo do retorno
    Error, // tipo do erro
    IDataApi // tipo do input
  >({
    mutationFn: async ({ endereco_id, payload }: IDataApi) => {
      return await handleAtualizarEndereco(token!, endereco_id, payload);
    },
    onSuccess: async () => {
      notifySuccess("Endereço atualizado com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["enderecos-tipos"] });
    },
  });

  return {
    atualizarEndereco: mutation.mutate, // chamada direta
    atualizarEnderecoAsync: mutation.mutateAsync, // se quiser await
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
